import styled from 'styled-components';

export const Box = styled.div`

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  margin: 20px auto;
  max-width: 800px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;

  h2 {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-row {
    margin-bottom: 20px;
  }

  .form-control,
  .form-select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
  }

  .grid-item {
    display: flex;
    flex-direction: column;
  }

  .restricted-directory-input {
    width: 90%;
  }

    .remove-directory-btn,
  .add-directory-btn {
    background-color: #8cc540;
    color: white;
    border: none;
    padding: 10px;
    width: 36px;
    height: 36px;
    padding: 0;
    cursor: pointer;
    border-radius: 100%;
    border-radius: 50%;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .button-row {
    display: flex;
    gap: 10px;
    justify-content: center;
  }

  .generate-btn {
    background-color: #8cc540;
    color: white;
    padding: 9px 8px;
    border-radius: 5px;
  }

  .reset-btn {
    background-color: rgb(65, 9, 15);
    color: white;
    padding: 9px 8px;
    border-radius: 5px;
  }

  .copy-btn,
  .download-btn {
    background-color: #8cc540;
    color: white;
    padding: 10px 20px;
    border-radius: 4px;
    text-align: center;
  }

  .result-box {
    background-color: #e9ecef;
    padding: 10px;
    border-radius: 4px;
    font-family: monospace;
    overflow-y: auto;
    max-height: 200px;
  }
    .tool-card {
  background: #ffffff;
  border: none;
  box-shadow: none;
}


  @media (max-width: 600px) {
    .grid-container {
      grid-template-columns: 1fr;
    }
  }
`;